//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileStockSearch', {
//        templateUrl: 'views/components/views/textileStockSearch/textileStockSearch.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'rememberService', 'textileStockSearchService', function (stateService, utilityService, rememberService, textileStockSearchService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                searchtext: ''
//            };

//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => searchItems() }
//                ],
//                setting: {},
//                itemsListTextileStocks: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await textileStockSearchService.getSetting())[0];
//            }
            
//            async function loadTextileStocks() {
//                if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;
                
//                vm.model.itemsListTextileStocks = [];
                
//                return vm.model.itemsListTextileStocks = await textileStockSearchService.listTextileStocks({ searchtext: vm.model.setting.searchtext });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                    	case 'searchtext':
//                            variableNames[key] = stateService.getCurrentName() + '.' + key;
//                    		break;
//                    	default:
//                    		variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                    		break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        variableValue = vm.model.setting.searchtext;
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }
            
//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') {
//                            rememberFunc('searchtext');
//                            loadTextileStocks();
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region SEARCH FUNCTIONS

//            function searchItems() {
//                if (vm.model.setting.searchtext > '') {
//                    rememberFunc('searchtext');
//                    loadTextileStocks();
//                }
//            }

//            vm.searchItems = searchItems;

//            // #endregion SEARCH FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') {
//                            rememberFunc('searchtext');
//                            loadTextileStocks();
//                        }
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext) !== true) return;

//                        if (vm.model.setting.searchtext > '') {
//                            rememberFunc('searchtext');
//                            loadTextileStocks();
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadTextileStocks();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
